import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'CustomArial';
    src: url(${CustomArial});
  } 
  
  .generated-images-holder-var34 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var34 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }
  .text-var34 {
    position: absolute;
    max-width: calc(100% - 30px);
    bottom: 30px;
    font-size: 45px;
    line-height: 1.2;
    text-align: left;
    color: #000;
    font-weight: 400;
    font-family: CustomArial;
    letter-spacing: -0.05px;
    background: red;
    width: fit-content;
    left: 0;
    right: 0;
    margin: auto;
    padding: 18px 39px 14px;
    background-color: white;
    &--top {
      bottom: auto;
      top: 30px;
    }
    p {
      display: inline-block;
      margin: 0;
    }
    p.custom-brakes {
      white-space: nowrap;
    }
  }

  .author-row-text-var34 {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .author-name-text-var34 {
    font-weight: 700;
    font-size: 20px;
    color: #000;
    padding: 0;
    font-family: Arial, Helvetica, sans-serif;
  }

  .author-name__blue {
    color: #3D5798;
  }

  .author-image-text-var34 {
    width: 53px;
    height: 53px;
    object-fit: cover;
    margin-right: 11px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .left-image-var34 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
  }
  .right-image-var34 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
  }
  .actual-photo-var34 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
    &--right {
      right: 0;
      left: auto;
    }
    &--top {
      top: 0;
      bottom: auto;
    }
  }
   .break-var34 {
    position: absolute;
    width: 12px;
    height: 100%;
    left: 0;
    background-color: white;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    &--black {
      background-color: black;
    }
  }
`;

export default VariationsStyles;
